module.exports = __webpack_public_path__ + "static/media/RaisingChildren_ios_2.600b7d95.jpg";